export const GET_VIDEOS_LOADING = "GET_VIDEOS_LOADING";
export const GET_VIDEOS_SUCCESS = "GET_VIDEOS_SUCCESS";
export const GET_VIDEOS_FAILURE = "GET_VIDEOS_FAILURE";
